import { default as atividades686zu3vh9kMeta } from "/Users/guilherme/www/ntask/financeiro/financeiro-front/pages/atividades.vue?macro=true";
import { default as autenticacaoflVjwHbMNkMeta } from "/Users/guilherme/www/ntask/financeiro/financeiro-front/pages/autenticacao.vue?macro=true";
import { default as googleXfo8LIciGYMeta } from "/Users/guilherme/www/ntask/financeiro/financeiro-front/pages/callback/google.vue?macro=true";
import { default as larkXzMCh4bViGMeta } from "/Users/guilherme/www/ntask/financeiro/financeiro-front/pages/callback/lark.vue?macro=true";
import { default as cadastrar_45contasUHVRa8nUYwMeta } from "/Users/guilherme/www/ntask/financeiro/financeiro-front/pages/configuracoes/cadastrar-contas.vue?macro=true";
import { default as cadastrar_45receitasLwkOACYw7WMeta } from "/Users/guilherme/www/ntask/financeiro/financeiro-front/pages/configuracoes/cadastrar-receitas.vue?macro=true";
import { default as competenciasTgKRCnmEbAMeta } from "/Users/guilherme/www/ntask/financeiro/financeiro-front/pages/configuracoes/competencias.vue?macro=true";
import { default as googlezqWaZqHsMUMeta } from "/Users/guilherme/www/ntask/financeiro/financeiro-front/pages/configuracoes/google.vue?macro=true";
import { default as index5w3v4BIlo7Meta } from "/Users/guilherme/www/ntask/financeiro/financeiro-front/pages/configuracoes/index.vue?macro=true";
import { default as larkmDRWnp6BVZMeta } from "/Users/guilherme/www/ntask/financeiro/financeiro-front/pages/configuracoes/lark.vue?macro=true";
import { default as notificacoes_45push6CEAR3hAnFMeta } from "/Users/guilherme/www/ntask/financeiro/financeiro-front/pages/configuracoes/notificacoes-push.vue?macro=true";
import { default as permissoesV37x5cBtysMeta } from "/Users/guilherme/www/ntask/financeiro/financeiro-front/pages/configuracoes/permissoes.vue?macro=true";
import { default as indexEGaD2PV9dfMeta } from "/Users/guilherme/www/ntask/financeiro/financeiro-front/pages/deposito-previo/index.vue?macro=true";
import { default as indexdSfRwceqXtMeta } from "/Users/guilherme/www/ntask/financeiro/financeiro-front/pages/index.vue?macro=true";
import { default as lark_45callbackWwif5QPeZrMeta } from "/Users/guilherme/www/ntask/financeiro/financeiro-front/pages/lark-callback.vue?macro=true";
import { default as _91id_93UvqJu3RbqPMeta } from "/Users/guilherme/www/ntask/financeiro/financeiro-front/pages/livro-diario-auxiliar/despesa/[id].vue?macro=true";
import { default as indexAp7dmuEovVMeta } from "/Users/guilherme/www/ntask/financeiro/financeiro-front/pages/livro-diario-auxiliar/despesa/index.vue?macro=true";
import { default as indexYbVqwKX9e4Meta } from "/Users/guilherme/www/ntask/financeiro/financeiro-front/pages/livro-diario-auxiliar/index.vue?macro=true";
import { default as notificacoesYx6H8eX04AMeta } from "/Users/guilherme/www/ntask/financeiro/financeiro-front/pages/notificacoes.vue?macro=true";
import { default as _91id_932VCPaz5v6xMeta } from "/Users/guilherme/www/ntask/financeiro/financeiro-front/pages/orcamentos/editar/[id].vue?macro=true";
import { default as _91id_93MKzVKS6yjPMeta } from "/Users/guilherme/www/ntask/financeiro/financeiro-front/pages/orcamentos/imprimir/[id].vue?macro=true";
import { default as index1I2Nz9DldeMeta } from "/Users/guilherme/www/ntask/financeiro/financeiro-front/pages/orcamentos/index.vue?macro=true";
import { default as novoUHTCuvxFtkMeta } from "/Users/guilherme/www/ntask/financeiro/financeiro-front/pages/orcamentos/novo.vue?macro=true";
import { default as _91id_93Kpvp13egRvMeta } from "/Users/guilherme/www/ntask/financeiro/financeiro-front/pages/orcamentos/pagar/[id].vue?macro=true";
import { default as _91id_93Sxnlhc6UMDMeta } from "/Users/guilherme/www/ntask/financeiro/financeiro-front/pages/orcamentos/visualizar/[id].vue?macro=true";
import { default as indexNNpT3smBYjMeta } from "/Users/guilherme/www/ntask/financeiro/financeiro-front/pages/outros-creditos/index.vue?macro=true";
import { default as politica_45de_45privacidadeLU7DBrc7v9Meta } from "/Users/guilherme/www/ntask/financeiro/financeiro-front/pages/politica-de-privacidade.vue?macro=true";
import { default as index7ChAnkDwIbMeta } from "/Users/guilherme/www/ntask/financeiro/financeiro-front/pages/prestacao-de-contas/index.vue?macro=true";
import { default as indexjogwfza2ZOMeta } from "/Users/guilherme/www/ntask/financeiro/financeiro-front/pages/recibo/index.vue?macro=true";
import { default as indexZCwqOxYwQmMeta } from "/Users/guilherme/www/ntask/financeiro/financeiro-front/pages/repasses/index.vue?macro=true";
export default [
  {
    name: "atividades",
    path: "/atividades",
    meta: atividades686zu3vh9kMeta || {},
    component: () => import("/Users/guilherme/www/ntask/financeiro/financeiro-front/pages/atividades.vue")
  },
  {
    name: "autenticacao",
    path: "/autenticacao",
    meta: autenticacaoflVjwHbMNkMeta || {},
    component: () => import("/Users/guilherme/www/ntask/financeiro/financeiro-front/pages/autenticacao.vue")
  },
  {
    name: "callback-google",
    path: "/callback/google",
    component: () => import("/Users/guilherme/www/ntask/financeiro/financeiro-front/pages/callback/google.vue")
  },
  {
    name: "callback-lark",
    path: "/callback/lark",
    component: () => import("/Users/guilherme/www/ntask/financeiro/financeiro-front/pages/callback/lark.vue")
  },
  {
    name: "configuracoes-cadastrar-contas",
    path: "/configuracoes/cadastrar-contas",
    component: () => import("/Users/guilherme/www/ntask/financeiro/financeiro-front/pages/configuracoes/cadastrar-contas.vue")
  },
  {
    name: "configuracoes-cadastrar-receitas",
    path: "/configuracoes/cadastrar-receitas",
    component: () => import("/Users/guilherme/www/ntask/financeiro/financeiro-front/pages/configuracoes/cadastrar-receitas.vue")
  },
  {
    name: "configuracoes-competencias",
    path: "/configuracoes/competencias",
    component: () => import("/Users/guilherme/www/ntask/financeiro/financeiro-front/pages/configuracoes/competencias.vue")
  },
  {
    name: "configuracoes-google",
    path: "/configuracoes/google",
    component: () => import("/Users/guilherme/www/ntask/financeiro/financeiro-front/pages/configuracoes/google.vue")
  },
  {
    name: "configuracoes",
    path: "/configuracoes",
    component: () => import("/Users/guilherme/www/ntask/financeiro/financeiro-front/pages/configuracoes/index.vue")
  },
  {
    name: "configuracoes-lark",
    path: "/configuracoes/lark",
    component: () => import("/Users/guilherme/www/ntask/financeiro/financeiro-front/pages/configuracoes/lark.vue")
  },
  {
    name: "configuracoes-notificacoes-push",
    path: "/configuracoes/notificacoes-push",
    component: () => import("/Users/guilherme/www/ntask/financeiro/financeiro-front/pages/configuracoes/notificacoes-push.vue")
  },
  {
    name: "configuracoes-permissoes",
    path: "/configuracoes/permissoes",
    component: () => import("/Users/guilherme/www/ntask/financeiro/financeiro-front/pages/configuracoes/permissoes.vue")
  },
  {
    name: "deposito-previo",
    path: "/deposito-previo",
    component: () => import("/Users/guilherme/www/ntask/financeiro/financeiro-front/pages/deposito-previo/index.vue")
  },
  {
    name: "index",
    path: "/",
    component: () => import("/Users/guilherme/www/ntask/financeiro/financeiro-front/pages/index.vue")
  },
  {
    name: "lark-callback",
    path: "/lark-callback",
    component: () => import("/Users/guilherme/www/ntask/financeiro/financeiro-front/pages/lark-callback.vue")
  },
  {
    name: "livro-diario-auxiliar-despesa-id",
    path: "/livro-diario-auxiliar/despesa/:id()",
    component: () => import("/Users/guilherme/www/ntask/financeiro/financeiro-front/pages/livro-diario-auxiliar/despesa/[id].vue")
  },
  {
    name: "livro-diario-auxiliar-despesa",
    path: "/livro-diario-auxiliar/despesa",
    component: () => import("/Users/guilherme/www/ntask/financeiro/financeiro-front/pages/livro-diario-auxiliar/despesa/index.vue")
  },
  {
    name: "livro-diario-auxiliar",
    path: "/livro-diario-auxiliar",
    component: () => import("/Users/guilherme/www/ntask/financeiro/financeiro-front/pages/livro-diario-auxiliar/index.vue")
  },
  {
    name: "notificacoes",
    path: "/notificacoes",
    component: () => import("/Users/guilherme/www/ntask/financeiro/financeiro-front/pages/notificacoes.vue")
  },
  {
    name: "orcamentos-editar-id",
    path: "/orcamentos/editar/:id()",
    component: () => import("/Users/guilherme/www/ntask/financeiro/financeiro-front/pages/orcamentos/editar/[id].vue")
  },
  {
    name: "orcamentos-imprimir-id",
    path: "/orcamentos/imprimir/:id()",
    meta: _91id_93MKzVKS6yjPMeta || {},
    component: () => import("/Users/guilherme/www/ntask/financeiro/financeiro-front/pages/orcamentos/imprimir/[id].vue")
  },
  {
    name: "orcamentos",
    path: "/orcamentos",
    component: () => import("/Users/guilherme/www/ntask/financeiro/financeiro-front/pages/orcamentos/index.vue")
  },
  {
    name: "orcamentos-novo",
    path: "/orcamentos/novo",
    component: () => import("/Users/guilherme/www/ntask/financeiro/financeiro-front/pages/orcamentos/novo.vue")
  },
  {
    name: "orcamentos-pagar-id",
    path: "/orcamentos/pagar/:id()",
    component: () => import("/Users/guilherme/www/ntask/financeiro/financeiro-front/pages/orcamentos/pagar/[id].vue")
  },
  {
    name: "orcamentos-visualizar-id",
    path: "/orcamentos/visualizar/:id()",
    component: () => import("/Users/guilherme/www/ntask/financeiro/financeiro-front/pages/orcamentos/visualizar/[id].vue")
  },
  {
    name: "outros-creditos",
    path: "/outros-creditos",
    component: () => import("/Users/guilherme/www/ntask/financeiro/financeiro-front/pages/outros-creditos/index.vue")
  },
  {
    name: "politica-de-privacidade",
    path: "/politica-de-privacidade",
    meta: politica_45de_45privacidadeLU7DBrc7v9Meta || {},
    component: () => import("/Users/guilherme/www/ntask/financeiro/financeiro-front/pages/politica-de-privacidade.vue")
  },
  {
    name: "prestacao-de-contas",
    path: "/prestacao-de-contas",
    component: () => import("/Users/guilherme/www/ntask/financeiro/financeiro-front/pages/prestacao-de-contas/index.vue")
  },
  {
    name: "recibo",
    path: "/recibo",
    component: () => import("/Users/guilherme/www/ntask/financeiro/financeiro-front/pages/recibo/index.vue")
  },
  {
    name: "repasses",
    path: "/repasses",
    component: () => import("/Users/guilherme/www/ntask/financeiro/financeiro-front/pages/repasses/index.vue")
  }
]